/**
 * Created by rak on 1/16/2016.
 */
'use strict';
angular.module('betosyswebapp').directive('fitIframeHeight', function ($window, $document, $timeout) {
  return {
    restrict: 'A',
    scope: {
      divIdNames: '=divid'
    },
    link: function (scope, element) {
      scope.docHeight = $document.height();
      var setHeight = function () {
        $timeout(function () {
          var divIdNames = scope.divIdNames.split(',');
          var _tmpHeight = $('header').height();
          for (var i = 0; i < divIdNames.length; i++) {
            _tmpHeight += $('#' + divIdNames[i]).height();
          }
          _tmpHeight += $('footer').height();

          element.css('min-height', ($(window).height() - (_tmpHeight + 30)) + 'px');
        }, 500);
      };

      scope.$watch('docHeight', function (newVal) {
        setHeight(newVal);
      });

      scope.$on('globalStyles:changed:layoutHorizontal', function (event, newVal) {
        setHeight(newVal);
      });

      $(window).on('resize', function () {
        setHeight();
      });
    }
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/iframeWindowHeightDiretive.js